// -- React Libraries
import React from 'react';
import PropTypes from 'prop-types';

class CircularProgressBar extends React.Component {
    constructor(props) {
      super(props);

      this.ArcWidth = props.arcWidth;
      this.ArcData = props.arcData;

      this.StrokeWidth = props.strokeWidth;
      this.StrokeColor = props.strokeColor;

      this.Percent = props.percentage;
      this.TextData = null;
      
      this.CanvasWidth = this.ArcWidth + (this.StrokeWidth / 2) + 10;

      this.ArcData.push({
          percentage: this.Percent / 100,
          strokeColor: this.StrokeColor
      });
      if (props.textData) {
          this.TextData = {
              TextColor: props.textData.fontColor || "#000000",
              FontSize: props.textData.fontSize || "16px"
          };
      }
    }

    _drawArc(ctx, percentage, strokeWidth, strokeColor) {
        var starting = Math.PI * 1.5;
        var ending = Math.PI * (1.5 + 2 * percentage);

        ctx.beginPath();
        ctx.arc(this.CanvasWidth / 2, this.CanvasWidth / 2, this.ArcWidth / 2 - 0.5, starting, ending);
        ctx.lineWidth = strokeWidth;
        ctx.strokeStyle = strokeColor;
        ctx.stroke();
    }

    componentDidMount() {
        this._updateCanvas();
    }

    componentDidUpdate() {
        this._updateCanvas();
    }

    _updateCanvas() {
        const ctx = this.refs.canvas.getContext('2d');
        ctx.clearRect(0, 0, this.CanvasWidth, this.CanvasWidth);
        this.ArcData.map( (data) => this._drawArc(ctx, data.percentage, this.StrokeWidth, data.strokeColor) );

        if (this.TextData) {
            ctx.fillStyle = this.TextData.TextColor;
            ctx.font = `${this.TextData.FontSize} Roboto`;
            ctx.textBaseline = 'middle';
            ctx.textAlign = "center";
            ctx.fillText(`${this.Percent}%`, this.CanvasWidth / 2, this.CanvasWidth / 2);
        }
    }

    render() {
        return (
            <canvas ref="canvas" width={this.CanvasWidth} height={this.CanvasWidth}/>
        );
    }
}

CircularProgressBar.propTypes = {
    arcWidth: PropTypes.number.isRequired,
    arcData: PropTypes.arrayOf(PropTypes.any).isRequired,
    strokeWidth: PropTypes.number.isRequired,
    strokeColor: PropTypes.string.isRequired,
    percentage: PropTypes.number.isRequired,
    textData: PropTypes.object
}

export default CircularProgressBar;


// WEBPACK FOOTER //
// ./src/components/CircularProgressBar/index.js